import logo from './logo.svg';
import './App.css';
import Weather from "./Weather";

function App() {
  return (
    <Weather/>
  );
}

export default App;
